export class register {
    campaign_id: number;
    customername: string;
    mobile: string;
    voucher_code: string;


constructor(values: Object = {}) {
    Object.assign(this, values);
}
}


// WEBPACK FOOTER //
// ./src/app/index/register.ts